import React from "react"

import {FieldGlistGroupProps} from "../../../../../render/glist/glist-group"

export default function FieldAccountType_GlistGroupStandard(props:FieldGlistGroupProps) {

    // Notice: value may be 'null' (string) because while grouping null value is automatically converted to string

    const option                = props.field._getOption(props.data.value)

    const groupColor            = _.get(option, 'color', null)
    const groupName             = _.get(option, 'label', props.field.noValueOptionLabel)

    const colorClass: string    = groupColor ? 'gd-c-{0}'.f(groupColor) : ''

    const groupNameClasses: string = Classes("group-cards", colorClass, {
        'colored-background': !!groupColor,
    })

    return (
        <div className={groupNameClasses}>
            <div className="text">{groupName}</div>
            {!!props.data.isCollapsed && <div className="counter">{props.data.counter}</div>}

            {!props.data.isCollapsed &&
                <div className="group-corners">
                    <div className={Classes("top-corner", colorClass)}/>
                </div>}
        </div>
    )
}
